import React, { useEffect, useState } from "react";
import { useRoute } from "../../../../hooks/useRoute";
import { useGroup } from "../../../../hooks/useGroup";
import empresaApi from "../../../../api/empresaApi";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

export default function Groups() {
  const { routes } = useRoute();
  const routesActive = routes.filter((r) => r.estado === 1 || r.estado === "1" || r.estado === true);
  const {
    groups,
    selectedGroup,
    handleSelectGrupos,
    saveGroups,
    handleNew,
    setForm,
    form,
    search,
    setSearch,
  } = useGroup();

  const [empresas, setEmpresas] = useState([]);
  useEffect(() => {
    empresaApi.getAll().then((res) => {
      setEmpresas(res.data || res || []);
    }).catch(err => console.error(err));
  }, []);
  const LIMITE = 15;
  const filteredGrupos = groups
    .filter(
      (g) =>
        (g.descripcion?.toLowerCase() || "").includes(search.toLowerCase()) ||
        (g.codigo?.toString() || "").includes(search)
    )
    .slice(0, search ? groups.length : LIMITE);

  return (
    <Page>
      {/* ================= PANEL IZQUIERDO ================= */}
      <Left>
        <HeaderRow>
          <h3>Grupos</h3>
          <BtnGeneral
            bg="cyan"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={handleNew}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <SearchInput
          placeholder="Buscar x Codigo, Descripcíon......"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {filteredGrupos.map((g) => (
            <RoleItem
              key={g.id}
              active={selectedGroup === g.id}
              onClick={() => handleSelectGrupos(g.id)}
            >
              <strong>
                {g.codigo} - {g.descripcion}
              </strong>
            </RoleItem>
          ))}
        </RoleListContainer>
      </Left>

      {/* ================= PANEL DERECHO ================= */}
      <Right>
        <HeaderRow>
          <h5>
            <strong>{form.id ? "Editar grupo" : "Nuevo grupo"}</strong>
          </h5>
          <BtnGeneral
            bg="green"
            padding="5px 9px"
            radius="6px"
            fw="500"
            onClick={saveGroups}
          >
            Guardar
          </BtnGeneral>
        </HeaderRow>

        <div style={{ display: "flex", gap: "20px", marginTop: "2px" }}>
          {/* COLUMNA 1 */}
          <div style={{ flex: 1 }}>
            <label>ID</label>
            <input disabled value={form.id} style={inputStyle} />
            <label>Codigo</label>
            <input
              value={form.codigo}
              onChange={(e) => setForm({ ...form, codigo: e.target.value })}
              style={inputStyle}
            />
            <label>Edad Inicial</label>
            <input
              value={form.inicial}
              onChange={(e) => setForm({ ...form, inicial: e.target.value })}
              style={inputStyle}
            />
            <label>Sexo</label>
            <SearchableSelect
              key={`sexo-${form.id || "new"}`}
              value={form.sexo || ""}
              onValueChange={(val) => setForm({ ...form, sexo: val })}
              options={[
                { value: "M", label: "M" },
                { value: "F", label: "F" },
                { value: "A", label: "A" },
              ]}
              placeholder="Seleccione..."
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
            <label>General</label>
            <SearchableSelect
              key={`general-${form.id || "new"}`}
              value={String(form.general ?? "0")}
              onValueChange={(val) => setForm({ ...form, general: parseInt(val, 10) })}
              options={[
                { value: "1", label: "SI" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
            <label>Visible</label>
            <SearchableSelect
              key={`visible-${form.id || "new"}`}
              value={String(form.visible ?? "1")}
              onValueChange={(val) => setForm({ ...form, visible: val })}
              options={[
                { value: "1", label: "SI" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
            <label>Estado</label>
            <SearchableSelect
              key={`estado-${form.id || "new"}`}
              value={String(form.estado ?? "1")}
              onValueChange={(val) => setForm({ ...form, estado: val })}
              options={[
                { value: "1", label: "ACTIVO" },
                { value: "0", label: "INACTIVO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
          </div>

          {/* COLUMNA 2 */}
          <div style={{ flex: 1 }}>
            <label>Ruta</label>
            <SearchableSelect
              key={`ruta-${form.id || "new"}`}
              value={form.idruta ? String(form.idruta) : ""}
              onValueChange={(val) => setForm({ ...form, idruta: val })}
              options={routesActive.map((r) => ({
                value: String(r.id),
                label: r.descripcion,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />

            <label>Descripcion</label>
            <input
              value={form.descripcion}
              onChange={(e) =>
                setForm({ ...form, descripcion: e.target.value })
              }
              style={inputStyle}
            />
            <label>Edad Final</label>
            <input
              value={form.final}
              onChange={(e) => setForm({ ...form, final: e.target.value })}
              style={inputStyle}
            />
            <label>Orden</label>
            <input
              type="number"
              value={form.orden}
              onChange={(e) => setForm({ ...form, orden: e.target.value })}
              style={inputStyle}
            />

            <label>Bloqueado</label>
            <SearchableSelect
              key={`bloqueado-${form.id || "new"}`}
              value={String(form.bloqueado ?? "0")}
              onValueChange={(val) => setForm({ ...form, bloqueado: val })}
              options={[
                { value: "1", label: "Si" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />

            <label>Empresa</label>
            <SearchableSelect
              key={`empresa-${form.id || "new"}`}
              value={form.id_empresa !== undefined && form.id_empresa !== null ? String(form.id_empresa) : "0"}
              onValueChange={(val) => setForm({ ...form, id_empresa: val })}
              options={[
                { value: "0", label: "Ninguna" },
                ...empresas.map((e) => ({
                  value: String(e.id),
                  label: e.nombre_empresa || e.descripcion || e.nombre || String(e.id),
                })),
              ]}
              placeholder="Seleccione empresa..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
          </div>
        </div>
      </Right>
    </Page>
  );
}

const inputStyle = {
  width: "100%",
  padding: "6px",
  marginBottom: "6px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
};

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
